/**
 * @owner @Appboy/core-objects
 */
export const appsCatalogFilteredSets = "/apps/catalog_filtered_sets";
